'use strict';
const angular = require('angular');

export class mailArchiveSelectorComponent {

  constructor() {
    'ngInject';
  }

  $onInit = function () {
    this.config = this.resolve.config;
  };

  ok() {
    this.close({$value: this.category});
  }

  cancel() {
    this.dismiss({$value: 'cancel'});
  }

}

export default angular.module('conduApp.mailArchiveSelectorComponent', [])
  .component('mailArchiveSelectorComponent', {
    template: require('./archive-selector.component.html'),
    bindings: {
      resolve: '<',
      config: '<',
      close: '&',
      dismiss: '&'
    },
    controller: mailArchiveSelectorComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/mail-composer/archive-selector/archive-selector.component.js